// Admin "Clippers" tab — applications from the /forms recruitment funnel.
import { useEffect, useState } from "react";
import { axiosInstance } from "../../config";
import toast from "react-hot-toast";

function rel(d) {
  if (!d) return "—";
  const s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60); if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60); if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function ClippersTab() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    axiosInstance.get("/clipper-apply")
      .then((r) => setItems(r.data.items || []))
      .catch((e) => { toast.error(e.response?.data?.error || "Failed to load clippers"); setItems([]); });
  }, []);

  if (!items) return <div className="admindash-empty admindash-shimmer">Loading…</div>;
  const withExp = items.filter((i) => i.experience === "Yes").length;

  return (
    <div className="admindash-section admindash-fade-in">
      <h2 className="admindash-section-title">
        Clipper applications <span className="muted">({items.length})</span>
      </h2>
      <div className="muted" style={{ fontSize: 13, marginBottom: 16 }}>
        {withExp} with personal-brand shorts experience · all routed to the Whop
      </div>
      {items.length === 0 ? (
        <div className="admindash-empty">No applications yet. Share <b>app.clipbait.ai/forms</b> to recruit editors.</div>
      ) : (
        <div className="clp-list">
          {items.map((c) => (
            <div key={c._id} className="clp-row">
              <div className="clp-main">
                <div className="clp-email">{c.email || "—"}</div>
                <div className="clp-meta muted">
                  {c.software === "Other" ? `Other: ${c.softwareOther || "—"}` : (c.software || "—")}
                  {c.portfolio && <> · <a href={c.portfolio.startsWith("http") ? c.portfolio : `https://${c.portfolio}`} target="_blank" rel="noreferrer">portfolio →</a></>}
                </div>
              </div>
              <span className={`clp-exp ${c.experience === "Yes" ? "yes" : "no"}`}>{c.experience === "Yes" ? "experienced" : "new"}</span>
              <span className="muted clp-when">{rel(c.createdAt)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
